import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProjectDto } from 'shared';
import { DataSharingService } from 'shared';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
import { ProjectService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';
import { Subject } from 'rxjs';

@Component({
    selector: 'lib-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    standalone: false
})
export class DeleteDialogComponent implements OnInit {

  projectForm!:UntypedFormGroup;
  projectDto!:ProjectDto;
  _db!:string;

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    private projectService: ProjectService,
    private dataSharingService: DataSharingService,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    // console.log("-------> delete-dialog project name = ", this.data[0].display_Name)
    // console.log("-------> delete-dialog project tenantName = ", this.tenantService.currentTenantName)
    //this.projectDto = this.data.projectDto;
   
    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = (data as any).role as Array<string>;
          userRoles.forEach((role: string) => {
            if (role === 'admin') {
              this._db = role;
            }
          });
        }
      }
    });
    
    this.createProjectForm();
   }

   createProjectForm(){
     this.projectForm = this.fb.group({
       id:[this.data[0].id],
       name:[this.data[0].name],
       url:[this.data[0].url]
     });
   }

  deleteProject() {     
     if(this.projectForm.valid) {
      this.dialogRef.close(this.projectForm.value);
     }
   }

  cancel(){
    this.dialogRef.close();
  }
}
